"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPairs = void 0;
const getPairs = (array, length = 2) => {
    let start = 0, pairs = [];
    while (start < array.length - 1) {
        pairs = pairs.concat([
            [...Array(length)].map((_, index) => array[start + index]),
        ]);
        start += 1;
    }
    return pairs;
};
exports.getPairs = getPairs;
